interface SettingItemProps {
    label?: string;
	title:string;
    isSwitchOn: boolean;
	callbackFunction?: (data: boolean) => void;
    children?: React.ReactNode;
}
export const SettingItemSwitch = ({ label, title,  isSwitchOn, callbackFunction, children }:SettingItemProps) => {
	return (
		<div className="settings__group">
			<div className="settings__row">
				<div className="settings__item">
					{label ? <div className="settings__item-label">{label}</div> : null}
					<div className="settings__item-value">{title}</div>
				</div>
				<div className="settings__control">
					<div className="switch" data-active={isSwitchOn}
						onClick={() => {
							callbackFunction &&
							callbackFunction(!isSwitchOn)
						}}
					>
						<div className="switch__thumb"></div>
					</div>
				</div>
			</div>
			{children}
		</div>
	)
}